import { Component, input, output } from '@angular/core';
import { Upload04Icon } from '@hugeicons/core-free-icons/index';
import { LucideUpload } from '@lucide/angular';

@Component({
  selector: 'ptl-upload-file-area',
  templateUrl: './upload-file-area.component.html',
  styleUrls: ['./upload-file-area.component.scss'],
})
export class UploadFileAreaComponent {
  linkText = input<string | undefined>(undefined);
  hintText = input<string>('');
  accept = input<string>('image/*');

  fileSelected = output<File>();
  clicked = output<void>();

  readonly Upload04Icon = Upload04Icon;

  isDragging = false;

  onAreaClick(): void {
    this.clicked.emit();
  }

  onFileChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      this.fileSelected.emit(inputElement.files[0]);
    }
    inputElement.value = '';
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    const file = event.dataTransfer?.files?.[0];
    if (file && this.isFileAccepted(file)) {
      this.fileSelected.emit(file);
    }
  }

  private isFileAccepted(file: File): boolean {
    const acceptedTypes = this.accept()
      .split(',')
      .map((type) => type.trim())
      .filter((type) => type.length > 0);

    if (acceptedTypes.length === 0) {
      return true;
    }

    const fileName = file.name.toLowerCase();
    const mimeType = file.type.toLowerCase();

    return acceptedTypes.some((type) => {
      const normalizedType = type.toLowerCase();
      if (normalizedType.startsWith('.')) {
        return fileName.endsWith(normalizedType);
      }
      if (normalizedType.endsWith('/*')) {
        return mimeType.startsWith(normalizedType.slice(0, -1));
      }
      return mimeType === normalizedType;
    });
  }

  protected readonly LucideUpload = LucideUpload;
}
